// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import moment from 'moment-timezone'
import classNames from 'classnames'
import { useOutsideClick, Calendar, SvgIcon, SecondaryButton } from 'ui_kit_qmd'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { initialState } from '../VisitsReducer'
import { CLEAR_TEXT } from '../../../utils/constants'
import './VisitsDateFilter.scss'
import { getDisplayDate } from '../../../utils/common'
import { routeParam } from '../constants'
import { useChangeSearchParams } from '../../../utils/useChangeSearchParams'
import { TIME_FOR_DATE_RANGE_REQUEST_FROM, TIME_FOR_DATE_RANGE_REQUEST_TO } from '../../../utils/dateUtils'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const formatDateToShow = (date) => moment(getDisplayDate(date)).format('dddd MMM DD YYYY')

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitsDateFilter = ({ stateFilter, dispatchFilter, closeFilter, closeRemarks }) => {
  const ref = useOutsideClick(closeFilter)
  const { onChangeSearchParam } = useChangeSearchParams()

  const [calendarMode, setCalendarMode] = useState('from')
  const [currentRange, setCurrentRange] = useState(stateFilter.date)
  const [dateValue, setDateValue] = useState(
    moment(getDisplayDate(stateFilter.date.fromDate)).format(TIME_FOR_DATE_RANGE_REQUEST_FROM),
  )

  useEffect(() => {
    window.addEventListener('popstate', closeFilter)

    return () => {
      window.removeEventListener('popstate', closeFilter)
    }
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onDateSelect = (value) => {
    if (calendarMode === 'from') {
      setCurrentRange({ fromDate: value, toDate: value })
      setCalendarMode('to')
      setDateValue(value)
    } else {
      setCurrentRange({ ...currentRange, toDate: value })
      setDateValue(value)

      const fromDate =
        stateFilter.timeZone ?
          moment(currentRange.fromDate)
            .parseZone()
            .tz(stateFilter.timeZone, true)
            .format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
        : moment(currentRange.fromDate).format(TIME_FOR_DATE_RANGE_REQUEST_FROM)
      const toDate =
        stateFilter.timeZone ?
          moment(value).parseZone().tz(stateFilter.timeZone, true).format(TIME_FOR_DATE_RANGE_REQUEST_TO)
        : moment(value).format(TIME_FOR_DATE_RANGE_REQUEST_TO)
      const diff = moment(toDate).diff(moment(fromDate), 'days')

      if (diff < 30 && diff >= 0) {
        const dateRangeSearchParamValue = JSON.stringify({ from: fromDate, to: toDate })
        dispatchFilter({ type: 'date', payload: { fromDate, toDate, isDateUpdated: true } })
        onChangeSearchParam({
          key: routeParam.DATE_RANGE,
          value: dateRangeSearchParamValue,
        })
        closeFilter()
        closeRemarks()
      } else {
        const error = getUserFriendlyErrorMessage(errorCodes.CANNOT_SELECT_PERIOD_MORE_THAN_30_DAYS)
        dispatchFilter({ type: 'error', payload: error })
        setCalendarMode('from')
        setCurrentRange(stateFilter.date)
      }
    }
  }

  const resetData = () => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    const initialDateRange = initialState({ timeZone: stateFilter.timeZone }).date
    const isDateChanged =
      currentRange.fromDate !== initialDateRange.fromDate || currentRange.toDate !== initialDateRange.toDate

    if (isDateChanged) {
      dispatchFilter({ type: 'date', payload: { ...initialDateRange } })
    }

    closeFilter()
    closeRemarks()
  }

  const onStartDateClick = () => setCalendarMode('from')

  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  const tileDisabled = ({ date }) =>
    calendarMode === 'from' ? date.getDate() === 0 : moment(date).isBefore(currentRange.fromDate, 'day')

  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const fromDate = formatDateToShow(currentRange.fromDate, stateFilter.timeZone)
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const toDate = formatDateToShow(currentRange.toDate, stateFilter.timeZone)

  return (
    <section ref={ref} className='visits-date-filter'>
      <section className='visits-selected-date'>
        <div
          role='presentation'
          className={classNames('visits-selected-from', { 'visits-date-selected': calendarMode === 'from' })}
          onClick={onStartDateClick}>
          <div className='visits-date-container'>
            <div className='visits-date-title'>Start date*</div>
            <div className='visits-date-value'>{fromDate}</div>
          </div>
          <div className='visits-date-icon'>
            <SvgIcon className='visits-calendar-icon' name='calendar' />
          </div>
        </div>
        <div className={classNames('visits-selected-to', { 'visits-date-selected': calendarMode === 'to' })}>
          <div className='visits-date-container'>
            <div className='visits-date-title'>End date*</div>
            <div className='visits-date-value'>{toDate}</div>
          </div>
          <div className='visits-date-icon'>
            <SvgIcon className='visits-calendar-icon' name='calendar' />
          </div>
        </div>
      </section>
      <Calendar dateValue={dateValue} onDateSelect={onDateSelect} tileDisabled={tileDisabled} />
      <SecondaryButton btnText={CLEAR_TEXT} onPress={resetData} className='reset-visits-date-filter' />
    </section>
  )
}
